const en = {
    "Home": "Home",
    "Liquidity": "Liquidity",
    "Swap": "Swap",
    "Stake": "Stake",
    "Portfolio": "Portfolio",
    "Connect Wallet": "Connect Wallet",
    "Disconnect": "Disconnect",
    "Welcome to TiFi Bank!": "Welcome to TiFi Bank!",
    "The First Decentralized Bank for Allverse": "The First Decentralized Bank for Allverse",
    "Exchange Cryptos with other Cryptos": "Exchange Cryptos with other Cryptos",
    "GO TO SWAP": "GO TO SWAP",
    "Enjoy Earning by Providing Liquidity": "Enjoy Earning by Providing Liquidity",
    "GO TO LIQUIDITY": "GO TO LIQUIDITY",
    "Provide Observerbility of Pool Portfolio": "Provide Observerbility of Pool Portfolio",
    "GO TO PORTFOLIO": "GO TO PORTFOLIO",
    "We appeciate for any feedbacks, please submit your feedbacks": "We appeciate for any feedbacks, please submit your feedbacks",
    "here": "here",
    ", and you will have a chance to get TIFI airdrop!": ", and you will have a chance to get TIFI airdrop!",
    "Haven’t got a crypto wallet yet?": "Haven’t got a crypto wallet yet?",
    "Learn How to Connect": "Learn How to Connect",
    "More": "More",
    "Price Chart": "Price Chart",
    "The market price chart from public exchanges. It shows the historical prices and the latest price in the chart may not be the same as the price show on the right panel of the page. The data chart may be incomplete due to data source provider.": "The market price chart from public exchanges. It shows the historical prices and the latest price in the chart may not be the same as the price show on the right panel of the page. The data chart may be incomplete due to data source provider.",
    "24H": "24H",
    "7D": "7D",
    "14D": "14D",
    "30D": "30D",
    "1Y": "1Y",
    "Term of Use": "Term of Use",
    "Privacy Policy": "Privacy Policy",
    "Cookies Policy": "Cookies Policy",
    "Disclaimer": "Disclaimer",
    "FAQ": "FAQ",
    "Contact Us": "Contact Us",
    "All rights reserved.": "All rights reserved.",
    "Balance": "Balance",
    "The number is invalid, maybe too big?": "The number is invalid, maybe too big?",
    "You are not on the BSC main net. Please switch to the main net.": "You are not on the BSC main net. Please switch to the main net.",
    "You have selected the same tokens, please select a different token.": "You have selected the same tokens, please select a different token.",
    "The pair doesn't exist, please select another pair.": "The pair doesn't exist, please select another pair.",
    "Not enough balance for the transaction.": "Not enough balance for the transaction.",
    "Transaction rejected by user.": "Transaction rejected by user.",
    "Transaction Submitted!": "Transaction Submitted!",
    "Check Transaction on BSCScan": "Check Transaction on BSCScan",
    "Swap Success!": "Swap Success!",
    "Approved, now you can swap!": "Approved, now you can swap!",
    "Approval Request submitted. Please hold on.": "Approval Request submitted. Please hold on.",
    "successful added": "successful added",
    "added failed": "added failed",
    "Cannot find address of": "Cannot find address of",
    ", have you connected MetaMask?": ", have you connected MetaMask?",
    "copied": "copied",
    "Price": "Price",
    "per": "per",
    "Price Impact Too High": "Price Impact Too High",
    "Insufficient Liquidity for This Trade": "Insufficient Liquidity for This Trade",
    "Insufficient Balance": "Insufficient Balance",
    "Swap Fee": "Swap Fee",
    "Swap Fee is 0.2%, where:": "Swap Fee is 0.2%, where:",
    "0.18% is paid to LP Providers": "0.18% is paid to LP Providers",
    "0.02% to the TiFi treasury": "0.02% to the TiFi treasury",
    "Price Impact": "Price Impact",
    "The difference between the market price and estimated price due to trade size.": "The difference between the market price and estimated price due to trade size.",
    "Route": "Route",
    "Routing through these tokens resulted in the best price for your trade.": "Routing through these tokens resulted in the best price for your trade.",
    "TIFI Sell Fee": "TIFI Sell Fee",
    "There is 2% of fee when selling TIFI, check ": "There is 2% of fee when selling TIFI, check ",
    "TiFi Token Whitepaper": "TiFi Token Whitepaper",
    " for more details.": " for more details.",
    "TIFI Buy Fee": "TIFI Buy Fee",
    "There is 1% of fee when buying TIFI, check ": "There is 1% of fee when buying TIFI, check ",
    "Swap from": "Swap from",
    "Swap to": "Swap to",
    "Select the first token": "Select the first token",
    "Select the second token": "Select the second token",
    "Only tokens that paired with ": "Only tokens that paired with ",
    " are listed": " are listed",
    "The following tokens are listed in TiFi Bank": "The following tokens are listed in TiFi Bank",
    "Stay Tuned!": "Stay Tuned!",
    "TiFi Bank Portfolio Page will be available in August 2022!": "TiFi Bank Portfolio Page will be available in August 2022!",
    "TiFi Bank Staking will be available in August 2022!": "TiFi Bank Staking will be available in August 2022!",
    "Your Liquidity": "Your Liquidity",
    "Connect to a wallet to view your liquidity.": "Connect to a wallet to view your liquidity.",
    "Add Liquidity": "Add Liquidity",
    "Enter Amount": "Enter Amount",
    "Approved! Now you can remove liquidity.": "Approved! Now you can remove liquidity.",
    "Liquidity Removal Success!": "Liquidity Removal Success!",
    "Remove": "Remove",
    "liquidity": "liquidity",
    "To receive": "To receive",
    "and": "and",
    "Amount (LP Tokens to Remove / Total)": "Amount (LP Tokens to Remove / Total)",
    "Max": "Max",
    "You will Receive": "You will Receive",
    "Pooled": "Pooled",
    "Enable": "Enable",
    "Liquidity Pool Token Balance": "Liquidity Pool Token Balance",
    "Share of pool": "Share of pool",
    "Add liquidity instead": "Add liquidity instead",
    "No liquidity found": "No liquidity found",
    "Approved! Now you can add liquidity.": "Approved! Now you can add liquidity.",
    "Liquidity Provision Success!": "Liquidity Provision Success!",
    "Tip: By adding liquidity you'll earn 0.18% of all trades on this pair proportional to your share of the pool. Fees are added to the pool, accrue in real time and can be claimed by withdrawing your liquidity.": "Tip: By adding liquidity you'll earn 0.18% of all trades on this pair proportional to your share of the pool. Fees are added to the pool, accrue in real time and can be claimed by withdrawing your liquidity.",
    "Input": "Input",
    "Select a token": "Select a token",
    "Price and pool share": "Price and pool share",
    "Insufficent balance": "Insufficent balance",
    "Supply": "Supply",
    "Connect to a wallet to add liquidity.": "Connect to a wallet to add liquidity.",
    "Insufficient balance to perform this transaction.": "Insufficient balance to perform this transaction.",
    "Stake TIFI to earn TIFI and WBNB with high APY": "Stake TIFI to earn TIFI and WBNB with high APY",
    "Pool Analytics": "Pool Analytics",
    "Stake Analytics": "Stake Analytics",
    "Your Stake": "Your Stake",
    "TIFI APY Last 24 Hours": "TIFI APY Last 24 Hours",
    "WBNB APY Last 24 Hours": "WBNB APY Last 24 Hours",
    "The TIFI APY when staking TIFI based on the transaction of last 24 hours. It is updated every day at 01:00 UTC.": "The TIFI APY when staking TIFI based on the transaction of last 24 hours. It is updated every day at 01:00 UTC.",
    "The WBNB APY when staking TIFI based on the transaction of last 24 hours. This is the APY of average case. It is updated every day at 01:00 UTC.": "The WBNB APY when staking TIFI based on the transaction of last 24 hours. This is the APY of average case. It is updated every day at 01:00 UTC.",
    "TIFI APY Last 30 Days": "TIFI APY Last 30 Days",
    "WBNB APY Last 30 Days": "WBNB APY Last 30 Days",
    "The average TIFI APY when staking TIFI based on the transaction of last 30 days. It is updated every day at 01:00 UTC.": "The average TIFI APY when staking TIFI based on the transaction of last 30 days. It is updated every day at 01:00 UTC.",
    "The WBNB APY when staking TIFI based on the transaction of last 30 days. This is the APY of average case. It is updated every day at 01:00 UTC.": "The WBNB APY when staking TIFI based on the transaction of last 30 days. This is the APY of average case. It is updated every day at 01:00 UTC.",
    "Connect to a wallet to view your stake records.": "Connect to a wallet to view your stake records.",
    "Stake TIFI": "Stake TIFI",
    "Go to TiFi.net": "Go to TiFi.net",
    "TiFi Bank Home Page": "TiFi Bank Home Page",
    "View TIFI on CoinMarketCap": "View TIFI on CoinMarketCap",
    "No stake record found": "No stake record found",
    "Notice: TiFi Bank charges 0.02 BNB of transaction fee for every stake, there are no fees when unstake. To receive the rewards, you have to stake TIFI at least 30 days. You will also get WBNB reward if you stake for more than 180 days.": "Notice: TiFi Bank charges 0.02 BNB of transaction fee for every stake, there are no fees when unstake. To receive the rewards, you have to stake TIFI at least 30 days. You will also get WBNB reward if you stake for more than 180 days.",
    "Connect to a wallet to stake.": "Connect to a wallet to stake.",
    "Staked on": "Staked on",
    "Unstake now, you will get": "Unstake now, you will get",
    ", you will get at least": ", you will get at least",
    "After": "After",
    "Unstake": "Unstake",
    "Total Amount of TIFI staked on ": "Total Amount of TIFI staked on ",
    "TIFI Staked": "TIFI Staked",
    "Reward": "Reward",
    "Notice: You are not getting the full reward of extra TIFI and WBNB because the staking time is less than 180 days!": "Notice: You are not getting the full reward of extra TIFI and WBNB because the staking time is less than 180 days!",
    "Enable Stake": "Enable Stake",
    "Approved! Now you can stake.": "Approved! Now you can stake.",
    "Click on the column name to sort pairs by its volume or APR.": "Click on the column name to sort pairs by its volume or APR.",
    "Pools": "Pools",
    "Name": "Name",
    "APY": "APY",
    "Action": "Action",
    "Track the earning trends for staking": "Track the earning trends for staking",
    "Stake APY Charts": "Stake APY Charts",
    "TIFI Stake Reward APY": "TIFI Stake Reward APY",
    "TIFI Reflection Reward APY": "TIFI Reflection Reward APY",
    "WBNB Stake Reward APY": "WBNB Stake Reward APY",
    "Note: The TIFI APY chart shows the comparison of TIFI reflection rate (holding TIFI in wallet) and TIFI staking rate. Both APY rates are determined by trading volume, but the staking takes extra trading fees to pay the earnings.": "Note: The TIFI APY chart shows the comparison of TIFI reflection rate (holding TIFI in wallet) and TIFI staking rate. Both APY rates are determined by trading volume, but the staking takes extra trading fees to pay the earnings.",
    "Note: The WBNB APY chart shows the APY earning rate for average users. You can only get the WBNB earning after your have staked TIFI for more than 180 days.": "Note: The WBNB APY chart shows the APY earning rate for average users. You can only get the WBNB earning after your have staked TIFI for more than 180 days.",
    "GO TO STAKE": "GO TO STAKE",
    "Notice: The amounts showing below is based on the rewards TiFi Bank collected so far. It is accumulating as more transactions happens on blockchain network.": "Notice: The amounts showing below is based on the rewards TiFi Bank collected so far. It is accumulating as more transactions happens on blockchain network.",
    "Win": "Win",
    "Approved! Now you can play Lucky Bags!": "Approved! Now you can play Lucky Bags!",
    "Lucky Bags": "Lucky Bags",
    "Buy mystery shopping bags and win TIFI!": "Buy mystery shopping bags and win TIFI!",
    "Jackpot": "Jackpot",
    "The amount TIFI in Jackpot prize pool, bet more and you will have higher chance to win!": "The amount TIFI in Jackpot prize pool, bet more and you will have higher chance to win!",
    "You Have Won": "You Have Won",
    "TiFi Token you have won in total so far.": "TiFi Token you have won in total so far.",
    "Approve to Play!": "Approve to Play!",
    "Select your bet": "Select your bet",
    "Rules": "Rules",
    "How To Play": "How To Play",
    "Connect Wallet.": "Connect Wallet.",
    "Select your bet, it cost from 1x (1 USD worth of TIFI) to 100x (100 USD worth of TIFI).": "Select your bet, it cost from 1x (1 USD worth of TIFI) to 100x (100 USD worth of TIFI).",
    "Deposit TiFi Token to your bag, this game will use the token in your bag for bet.": "Deposit TiFi Token to your bag, this game will use the token in your bag for bet.",
    "Choose your Lucky Bag from 12 unrevealed bags. The prizes in Lucky Bags are random.": "Choose your Lucky Bag from 12 unrevealed bags. The prizes in Lucky Bags are random.",
    "Win prize on the spot! Everyone has the chance to win Jackpot! Prizes are paid via TIFI.": "Win prize on the spot! Everyone has the chance to win Jackpot! Prizes are paid via TIFI.",
    "Bet Amount": "Bet Amount",
    "Bets are paid via TIFI, 1x is 1 USD worth of TIFI, 2x is 2 USD worth of TIFI, and so on.": "Bets are paid via TIFI, 1x is 1 USD worth of TIFI, 2x is 2 USD worth of TIFI, and so on.",
    "Here are the bet amounts based on current rate of TIFI:": "Here are the bet amounts based on current rate of TIFI:",
    "Prizes": "Prizes",
    "Prizes are reflected in the Balance in Your Bag immediately after your bet. You can withdraw TIFI from your bag to your wallet any time.": "Prizes are reflected in the Balance in Your Bag immediately after your bet. You can withdraw TIFI from your bag to your wallet any time.",
    "Usually it takes less than 30 seconds to reveal the prize after you selected the Lucky Bag.": "Usually it takes less than 30 seconds to reveal the prize after you selected the Lucky Bag.",
    "There are 6 prizes of Lucky Bags:": "There are 6 prizes of Lucky Bags:",
    "Bronze Bag": "Bronze Bag",
    "Silver Bag": "Silver Bag",
    "Golden Bag": "Golden Bag",
    "Sapphire Blue Bag": "Sapphire Blue Bag",
    "Ruby Red Bag": "Ruby Red Bag",
    "Win 10% of bet amount.": "Win 10% of bet amount.",
    "Win 50% of bet amount.": "Win 50% of bet amount.",
    "Win 200% of bet amount.": "Win 200% of bet amount.",
    "Win 500% of bet amount.": "Win 500% of bet amount.",
    "Win 1000% of bet amount.": "Win 1000% of bet amount.",
    "You will win all TIFI from accumulated Jackpot pool.": "You will win all TIFI from accumulated Jackpot pool.",
    "Top Winners!": "Top Winners!",
    "Message from Lucky Bag": "Message from Lucky Bag",
    "Network error, make sure you have internet connection!": "Network error, make sure you have internet connection!",
    "Sorry, you don't have sufficient balance to bet!": "Sorry, you don't have sufficient balance to bet!",
    "Welcome! Please connect wallet first.": "Welcome! Please connect wallet first.",
    "Oops! Something wrong when bet, the TIFI you have paid has been refunded.": "Oops! Something wrong when bet, the TIFI you have paid has been refunded.",
    "You have selected the bag:": "You have selected the bag:",
    "Please select your Lucky Bag!": "Please select your Lucky Bag!",
    "Congratulations!": "Congratulations!",
    "You have won a ": "You have won a ",
    "Hold on! Your lucky bag will be revealed in a few seconds!": "Hold on! Your lucky bag will be revealed in a few seconds!",
    "You've won ": "You've won ",
    "You are paying ": "You are paying ",
    " for a Lucky Bag!": " for a Lucky Bag!",
    "Bet again!": "Bet again!",
    "Lucky Bags Statistics": "Lucky Bags Statistics",
    "The statistics about Top Winners and Jackpot Winners": "The statistics about Top Winners and Jackpot Winners",
    "Play Now!": "Play Now!",
    "Total Winners:": "Total Winners:",
    "Top Winners": "Top Winners",
    "Jackpot Prize Pool: ": "Jackpot Prize Pool: ",
    "Jackpot Winners": "Jackpot Winners",
    "Winner": "Winner",
    "Total Win ($TIFI)": "Total Win ($TIFI)",
    "Jackpot ($TIFI)": "Jackpot ($TIFI)",
    "Winning Date": "Winning Date",
    "No Records Yet.": "No Records Yet.",
    "Balance in Your Bag": "Balance in Your Bag",
    "Click Deposit Button Below to Add TIFI & Play!": "Click Deposit Button Below to Add TIFI & Play!",
    "Deposit": "Deposit",
    "Withdraw": "Withdraw",
    "Approve the deposit first (no need to do every time), enter the amount and Deposit to Your Bag!": "Approve the deposit first (no need to do every time), enter the amount and Deposit to Your Bag!",
    "You can bet many times as long as there are sufficient TIFI in your bag. If current bet amount is less than the balance in your bag, you have to deposit more TIFI to continue.": "You can bet many times as long as there are sufficient TIFI in your bag. If current bet amount is less than the balance in your bag, you have to deposit more TIFI to continue.",
    "Withdraw Submitted!": "Withdraw Submitted!",
    "Withdraw Success!": "Withdraw Success!",
    "Deposit Submitted!": "Deposit Submitted!",
    "Deposit Success!": "Deposit Success!",
    "Deposit To Your Bag!": "Deposit To Your Bag!",
    "Sorry you don't have enough TIFI for bet, please deposit more TIFI to your bag!": "Sorry you don't have enough TIFI for bet, please deposit more TIFI to your bag!",
    "Total Amount of TIFI you want to withdraw": "Total Amount of TIFI you want to withdraw",
    "Withdraw To Your Wallet!": "Withdraw To Your Wallet!",
    "TVL in Staking Pool": "TVL in Staking Pool",
    "Crypto Loan": "Crypto Loan",
    "Supply crypto assets to earn interests and get fast loan without credit check.": "Supply crypto assets to earn interests and get fast loan without credit check.",
    "Supplied Assets": "Supplied Assets",
    "Total value of your supplied assets.": "Total value of your supplied assets.",
    "N/A": "N/A",
    "Max. Borrow": "Max. Borrow",
    "This value is estimation of the maximum asset value you can borrow. Because of fluctuated market, you may not be able to borrow so much.": "This value is estimation of the maximum asset value you can borrow. Because of fluctuated market, you may not be able to borrow so much.",
    "Current Borrow": "Current Borrow",
    "The current value of assets you have borrowed.": "The current value of assets you have borrowed.",
    "Health Level": "Health Level",
    "The health level of your account. You need pay attention to your health level all the time. If your health level is WARNING or UNHEALTHY, you need pay your debts as soon as possible. If health level is UNHEALTHY, you cannot borrow any assets from this platform.": "The health level of your account. You need pay attention to your health level all the time. If your health level is WARNING or UNHEALTHY, you need pay your debts as soon as possible. If health level is UNHEALTHY, you cannot borrow any assets from this platform.",
    "Connect to a wallet to view assets.": "Connect to a wallet to view assets.",
    "Lending APY": "Lending APY",
    "Borrowing APY": "Borrowing APY",
    "The amount of the tokens in the reserve plus tokens borrowed": "The amount of the tokens in the reserve plus tokens borrowed",
    "Available": "Available",
    "The maximum amount of tokens that users can borrow from the pool.": "The maximum amount of tokens that users can borrow from the pool.",
    "Credit": "Credit",
    "The balance of amount of token you have deposited.": "The balance of amount of token you have deposited.",
    "Debt": "Debt",
    "The balance of the amount of token you have borrowed.": "The balance of the amount of token you have borrowed.",
    "Borrow": "Borrow",
    "Repay": "Repay",
    "No lending pool found": "No lending pool found",
    "Please connect to wallet first!": "Please connect to wallet first!",
    "Borrow Success!": "Borrow Success!",
    "Borrow Quota": "Borrow Quota",
    "The maxium value of assets you can borrow in the selected token.": "The maxium value of assets you can borrow in the selected token.",
    "Pool Balance": "Pool Balance",
    "The current balance in lending pool.": "The current balance in lending pool.",
    "Notice: WBNB is the wrapper token of BNB, you can convert between BNB and WBNB without transaction fee at ": "Notice: WBNB is the wrapper token of BNB, you can convert between BNB and WBNB without transaction fee at ",
    "Maximum": "Maximum",
    "Current Interest Rate:": "Current Interest Rate:",
    "Exceed the quota": "Exceed the quota",
    "Please go back to select an action you want to take.": "Please go back to select an action you want to take.",
    "Deposit Asset": "Deposit Asset",
    "Available in Pool": "Available in Pool",
    "Enable Deposit for": "Enable Deposit for",
    "Insufficient balance": "Insufficient balance",
    "Repay Success!": "Repay Success!",
    "Repay Asset": "Repay Asset",
    "Enable Repay for": "Enable Repay for",
    "Withdraw Asset": "Withdraw Asset",
    "The borrow or withdraw amount will make your account unhealthy, please try a smaller amount.": "The borrow or withdraw amount will make your account unhealthy, please try a smaller amount.",
    "Loan": "Loan",
    "UNHEALTHY": "UNHEALTHY",
    "WARNING": "WARNING",
    "FAIR": "FAIR",
    "GOOD": "GOOD",
    "VERY GOOD": "VERY GOOD",
    "Assets": "Assets",
    "You can unwrap WBNB for BNB or wrap BNB for WBNB with no trading fees. Exchange rate is always 1 to 1.": "You can unwrap WBNB for BNB or wrap BNB for WBNB with no trading fees. Exchange rate is always 1 to 1.",
    "Save & Loan": "SAVE & LOAN",
    "GO TO SAVE & LOAN": "GO TO SAVE & LOAN",
    "Circulating Supply": "Circulating Supply",
    "Your TIFI Balance": "Your TIFI Balance",
    "TVL": "TVL",
    "Trading Vol. Last 24 Hours": "Trading Vol. Last 24 Hours",
    "Burnt": "Burnt",
    "Holders": "Holders",
    "Stake TIFI for 180 days and Receive both TIFI and WBNB Rewards!": "Stake TIFI for 180 days and Receive both TIFI and WBNB Rewards!",
    "Amount to Unstake": "Amount to Unstake",
    "Cannot add address of": "Cannot add address of",
    "GO TO PLAY": "GO TO PLAY",
    "GO TO CRYPTO LOAN": "GO TO CRYPTO LOAN",
    "START EARNING": "START EARNING",
    "Start Earning!": "Start Earning!",
    "Lock To Earn": "Lock To Earn",
    "Lock to earn": "Lock to earn",
    "Lock TiFi Token with fix period for high return": "Lock TiFi Token with fix period for high return",
    "This exclusive program offers high returns (up to 100% of APR) for locking TiFi Token with fix period.": "This exclusive program offers high returns (up to 100% of APR) for locking TiFi Token with fix period.",
    "Learn more": "Learn more",
    "TVL in Staking Lock": "TVL in Staking Lock",
    "Total TiFi Token Locked": "Total TiFi Token Locked",
    "Maximum APR": "Maximum APR",
    "Your Earning Records": "Your Earning Records",
    "100 % + Reflection": "100 % + Reflection",
    "The total value locked in US dollars.": "The total value locked in US dollars.",
    "The total amount of TiFi Token locked in staking lock.": "The total amount of TiFi Token locked in staking lock.",
    "The maximum APR you can get, you need follow the terms of lock to earn.": "The maximum APR you can get, you need follow the terms of lock to earn.",
    "Connect to a wallet to view your earning records.": "Connect to a wallet to view your earning records.",
    "Time of Deposit": "Time of Deposit",
    "Time of Maturity": "Time of Maturity",
    "Principal": "Principal",
    "Reflection Reward Till Now": "Reflection Reward Till Now",
    "Fix Rate Reward": "Fix Rate Reward",
    "You cannot withdraw or change the deposit until the time of maturity.": "You cannot withdraw or change the deposit until the time of maturity.",
    "By clicking the Withdraw button, you will receive ": "By clicking the Withdraw button, you will receive ",
    "No lock record found": "No lock record found",
    "Lock TiFi Token and Earn!": "Lock TiFi Token and Earn!",
    "Earning Terms (Click one row to start)": "Earning Terms (Click one row to start)",
    "Enable Earning": "Enable Earning",
    "Term Period": "Term Period",
    "Minimum Deposit (TIFI)": "Minimum Deposit (TIFI)",
    "APR": "APR",
    "Review Earning Term": "Review Earning Term",
    "You are going to deposit TiFi Tokens with the following term:": "You are going to deposit TiFi Tokens with the following term:",
    "Deposit Amount: ": "Deposit Amount: ",
    "Deposit Period: ": "Deposit Period: ",
    "Days": "Days",
    "Reward: ": "Reward: ",
    " and reflection rewards": " and reflection rewards",
    "By clicking the button below, I acknowledged that above terms cannot be changed AND I am not able to withdraw the principal or rewards during the period show above.": "By clicking the button below, I acknowledged that above terms cannot be changed AND I am not able to withdraw the principal or rewards during the period show above.",
    "Accept and Deposit": "Accept and Deposit",
    "Approved! Now you can start earning.": "Approved! Now you can start earning.",
    "Transaction submitted! Please wait a few seconds for completion.": "Transaction submitted! Please wait a few seconds for completion.",
    "Fiat Buy": "Fiat Buy",
    "Visa & Mastercard": "Visa & Mastercard",
    "BUY WITH BANK CARDS": "BUY WITH BANK CARDS",
    "Buy TiFi Token with Visa and Mastercard!": "Buy TiFi Token with Visa and Mastercard!"
}

export default en